import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ResolvedTheme, ThemePreference } from 'constants/theme';
import { readStoredThemePreference, resolveTheme, systemPrefersDark } from 'helper/theme';

/**
 * Preferência de tema do usuário. Não entra no redux-persist: tem chave própria no
 * localStorage (`ee-theme`), que `public/theme-init.js` lê antes do React montar —
 * assim a página já nasce no tema certo, sem piscar branco.
 */
interface ThemeState {
  preference: ThemePreference;
  systemPrefersDark: boolean;
}

const initialState: ThemeState = {
  preference: readStoredThemePreference(),
  systemPrefersDark: systemPrefersDark(),
};

export const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    setThemePreference: (state, action: PayloadAction<ThemePreference>) => {
      state.preference = action.payload;
    },
    setSystemPrefersDark: (state, action: PayloadAction<boolean>) => {
      state.systemPrefersDark = action.payload;
    },
  },
});

export const selectThemePreference = (state: any): ThemePreference => state.theme.preference;
export const selectSystemPrefersDark = (state: any): boolean => state.theme.systemPrefersDark;
/** Tema escolhido já resolvido ("sistema" vira claro/escuro). Não considera a rota. */
export const selectResolvedTheme = (state: any): ResolvedTheme => resolveTheme(
  state.theme.preference,
  state.theme.systemPrefersDark,
);

export const { setThemePreference, setSystemPrefersDark } = themeSlice.actions;
export default themeSlice.reducer;
